import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AuthProvider, RequireAuth } from './auth/AuthProvider';
import { AppShell } from './components/Shell';
import { UploadProvider } from './upload/UploadQueue';
import { Accounts } from './routes/Accounts';
import { Activity } from './routes/Activity';
import { AdminApiKeys } from './routes/AdminApiKeys';
import { AdminAudit } from './routes/AdminAudit';
import { AdminSettings } from './routes/AdminSettings';
import { Buckets } from './routes/Buckets';
import { Dashboard } from './routes/Dashboard';
import { Dock } from './routes/Dock';
import { LoggedOut } from './routes/LoggedOut';
import { NotFound } from './routes/NotFound';
import { ObjectBrowser } from './routes/ObjectBrowser';

export function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <UploadProvider>
          <Routes>
            {/* Public landing — always accessible, no auto-redirect */}
            <Route path="/" element={<Dock />} />
            {/* SSO post-logout landing */}
            <Route path="/logged-out" element={<LoggedOut />} />

            {/* Authenticated app */}
            <Route
              element={
                <RequireAuth fallback={<Navigate to="/" replace />}>
                  <AppShell />
                </RequireAuth>
              }
            >
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/accounts" element={<Accounts />} />
              <Route path="/accounts/:id/buckets" element={<Buckets />} />
              <Route path="/accounts/:id/buckets/:bucket" element={<ObjectBrowser />} />
              <Route path="/activity" element={<Activity />} />
              <Route path="/admin/settings" element={<AdminSettings />} />
              <Route path="/admin/audit" element={<AdminAudit />} />
              <Route path="/admin/api-keys" element={<AdminApiKeys />} />
            </Route>

            <Route path="*" element={<NotFound />} />
          </Routes>
        </UploadProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
